export const SendMessageIcon = ({ disabled, onClick, color }) => {
  const fill = disabled ? "#414A6E" : "#3365FF";

  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className="pointer t-02 svg-icon scale-1-1"
    >
      <path
        d="M16.5642 7.80084L8.7175 3.8775C3.44666 1.2375 1.28333 3.40083 3.92333 8.67167L4.72083 10.2667C4.95 10.7342 4.95 11.275 4.72083 11.7425L3.92333 13.3283C1.28333 18.5992 3.4375 20.7625 8.7175 18.1225L16.5642 14.1992C20.0842 12.4392 20.0842 9.56084 16.5642 7.80084ZM13.6033 11.6875H8.65333C8.2775 11.6875 7.96583 11.3758 7.96583 11C7.96583 10.6242 8.2775 10.3125 8.65333 10.3125H13.6033C13.9792 10.3125 14.2908 10.6242 14.2908 11C14.2908 11.3758 13.9792 11.6875 13.6033 11.6875Z"
        fill={color || fill}
      />
    </svg>
  );
};
